export default __webpack_public_path__ + "static/media/NIAS0010.34I-32715_-17890_0.5a0f1b57.jpg";